import {Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import { SelectedLocation } from '../../services/noon-reports.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
  selector: 'app-fleet-status-toolbar',
  templateUrl: './fleet-status-toolbar.component.html',
  styleUrls: ['./fleet-status-toolbar.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports:[SharedModule,
    MatButtonModule,
    MatCheckboxModule
  ]
})
export class FleetStatusToolbarComponent implements OnInit {
  @Output()
    itemsSelected: EventEmitter<SelectedLocation[]> = new EventEmitter<SelectedLocation[]>();
  locations: SelectedLocation[] = [];
  active!: boolean;
  visible!: boolean;

  ngOnInit() {
    this.active = true;
    this.visible = false;
  }

  onSelectAll() {
    this.active = !this.active;
    this.locations.forEach(i => {
      i.selected = this.active;
    });
    if (this.itemsSelected) {
      this.itemsSelected.emit(this.locations);
    }
  }

  onItemSelectedInternal(i:any) {
    i.selected = !i.selected;
    if (this.itemsSelected) {
      this.itemsSelected.emit(this.locations);
    }
  }

}
